<dx-scroll-view  (onScroll)="scroll($event)">
<div class="register-merchant-form-container">
    <div class="register-merchant-form dx-swatch-dark">
      <form [formGroup]="registrationForm">
        <mat-stepper #stepper [animationDuration]="'0ms'">
          
          <ng-template matStepperIcon="edit">
            <mat-icon>check_circle_outline</mat-icon>
          </ng-template>
        
          <ng-template matStepperIcon="done">
            <mat-icon>check</mat-icon>
          </ng-template>
        
          <!-- Custom icon with a context variable. *ngIf="registrationForm.invalid && (registrationForm.dirty || registrationForm.touched)" -->
          <ng-template matStepperIcon="number" let-index="index">
            {{index + 1}}
          </ng-template>

          <mat-step [stepControl]="registrationForm.get('companyDetails')!" [hasError]="hasStepError('companyDetails')">
            <ng-template matStepLabel>Company Details</ng-template>
            <app-company-details #companysubComponent
              formGroupName="companyDetails"
              [currencies]="allCurrencies"
              (notifyContainerDataChanged)="dataChanged($event)"
              
              ></app-company-details>
            <div class="stepper-buttons">

              <dx-toolbar>
                <dxi-item location="before">
                  <button mat-button matStepperNext>
                    Next
                    <mat-icon aria-hidden="false" aria-label="Next step" iconPositionEnd
                      >arrow_forward</mat-icon
                    >
                  </button>
                  
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                  <dx-button
                    text="Cancel"
                    stylingMode="outlined"
                    type="normal"
                    [disabled]="!isDataChanged"
                    (onClick)="cancel('companyDetails')"
                  >
                  </dx-button>
                </dxi-item>
              </dx-toolbar>
            </div>
          </mat-step>
          <mat-step [stepControl]="registrationForm.get('contactDetails')!" [hasError]="hasStepError('contactDetails')">
            <ng-template matStepLabel>
              Contact Details 
            </ng-template>
            <app-contact-details #contactssubComponent
              formGroupName="contactDetails"
              (notifyContainerDataChanged)="dataChanged($event)"  
            >
            </app-contact-details>
            <div class="stepper-buttons">
              <dx-toolbar [class.scrolled]="isContentScrolled">
                <dxi-item location="before">
                  <button mat-button matStepperPrevious>
                    Back
                    <mat-icon aria-hidden="false" aria-label="Previous step">arrow_back</mat-icon>
                  </button>
                  <button mat-button matStepperNext>
                    Next
                    <mat-icon aria-hidden="false" aria-label="Next step" iconPositionEnd
                      >arrow_forward</mat-icon
                    >
                  </button>
                  
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                  <dx-button
                    text="Cancel"
                    stylingMode="outlined"
                    type="normal"
                    [disabled]="!isDataChanged"
                    (onClick)="cancel()"
                  >
                  </dx-button>
                </dxi-item>
                
              </dx-toolbar>
            </div>
          </mat-step>
          <mat-step [stepControl]="registrationForm.get('addressDetails')!" [hasError]="hasStepError('addressDetails')">
            <ng-template matStepLabel>Address</ng-template>
            <app-address #addresssubComponent
              formGroupName="addressDetails"
              (notifyContainerDataChanged)="dataChanged($event)"
              [class.scrolled]="isContentScrolled"
              >
            </app-address>
            <div class="stepper-buttons">
              <dx-toolbar [class.scrolled]="isContentScrolled">
                <dxi-item location="before">
                  <button mat-button matStepperPrevious>
                    Back
                    <mat-icon aria-hidden="false" aria-label="Previous step">arrow_back</mat-icon>
                  </button>
                  <button mat-button matStepperNext>
                    Next
                    <mat-icon aria-hidden="false" aria-label="Next step" iconPositionEnd
                      >arrow_forward</mat-icon
                    >
                  </button>
                   </dxi-item>

                <dxi-item location="after" locateInMenu="never">
                  <dx-button
                    text="Cancel"
                    stylingMode="outlined"
                    type="normal"
                    [disabled]="!isDataChanged"
                    (onClick)="cancel()"
                  >
                  </dx-button>
                </dxi-item>
                
              </dx-toolbar>
            </div>
          </mat-step>
          <mat-step [stepControl]="registrationForm.get('directDebitDetails')!" [hasError]="hasStepError('directDebitDetails')">
            <ng-template matStepLabel>Direct Debit Details</ng-template>
            
              <app-direct-debit-instructions #directdebitinssubComponent
                formGroupName = "directDebitDetails"
                [accountTypes]="AllAccountTypes"
                (notifyContainerDataChanged)="dataChanged($event)">
              </app-direct-debit-instructions>
              <div class="stepper-buttons">
                <dx-toolbar [class.scrolled]="isContentScrolled">
                  <dxi-item location="before">
                    <button mat-button matStepperPrevious>
                      Back
                      <mat-icon aria-hidden="false" aria-label="Previous step">arrow_back</mat-icon>
                    </button>
                    <button mat-button matStepperNext>
                      Next
                      <mat-icon aria-hidden="false" aria-label="Next step" iconPositionEnd
                        >arrow_forward</mat-icon
                      >
                    </button>
                    </dxi-item>
                    
                  <dxi-item location="after" locateInMenu="never">
                    <dx-button
                      text="Cancel"
                      stylingMode="outlined"
                      type="normal"
                      [disabled]="!isDataChanged"
                      (onClick)="cancel()"
                    >
                    </dx-button>
                  </dxi-item>
                  
                </dx-toolbar>
              </div>
          </mat-step>
          <!--
          <mat-step [stepControl]="registrationForm.get('documents')!" *ngIf="this.DBMerchantId > 0">
            <ng-template matStepLabel>
              Documents
              </ng-template>
           <app-documents
                formGroupName = "documents"
                [merchantId]="DBMerchantId">
              </app-documents>
            <div class="stepper-buttons">
              <dx-toolbar class="theme-dependent" [class.scrolled]="isContentScrolled">
                <dxi-item location="before">
                  <button mat-button matStepperPrevious>
                    Back
                    <mat-icon aria-hidden="false" aria-label="Previous step">arrow_back</mat-icon>
                  </button>
                  <button mat-button matStepperNext>
                    Next
                    <mat-icon aria-hidden="false" aria-label="Next step" iconPositionEnd
                      >arrow_forward</mat-icon
                    >
                  </button>
                   </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                  <dx-button
                    text="Cancel"
                    stylingMode="outlined"
                    type="normal"
                    [disabled]="!isDataChanged"
                    (onClick)="cancel()"
                  >
                  </dx-button>
                </dxi-item>
                
              </dx-toolbar>
              
            </div>
          </mat-step>
          -->
          <mat-step [stepControl]="registrationForm.get('services')!" [hasError]="hasStepError('services')">
            <ng-template matStepLabel>Services and Wallets</ng-template>
           <app-register-merchant-services #servicesubComponent
                formGroupName = "services"
                (notifyContainerDataChanged)="dataChanged($event)">
              </app-register-merchant-services>
            <div class="stepper-buttons">
              <dx-toolbar [class.scrolled]="isContentScrolled">
                <dxi-item location="before">
                  <button mat-button matStepperPrevious>
                    Back
                    <mat-icon aria-hidden="false" aria-label="Previous step">arrow_back</mat-icon>
                  </button>
                  
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                  <dx-button
                    text="Cancel"
                    stylingMode="outlined"
                    type="normal"
                    [disabled]="!isDataChanged"
                    (onClick)="cancel()"
                  >
                  </dx-button>
                </dxi-item>
                
                <dxi-item location="after" locateInMenu="never">
                  <!-- if company form is not valid -->
                  <dx-button
                    [disabled]="!isCompanyFormValid" 
                    text="Submit"
                    icon="save"
                    type="default"
                    stylingMode="contained"
                    (onClick)="submitForm(true,$event)"
                  >
                  </dx-button>
                </dxi-item>
              </dx-toolbar>
            </div>
          </mat-step>
        </mat-stepper>
      </form>
    </div>
    
  </div>
